import { SimpleList } from "@/components/list";

export const FEATURES_CONSTANTS = {
  title: "What Makes Our Platform Modern?",
  desc: "As threats grow more sophisticated, OneMind stays ahead by integrating the latest frameworks and intelligence into every layer of protection.",
  list: [
    {
      title: "Threat Intelligence Integration (TII)",
      subTitle:
        "Leverage real-time threat intelligence to detect adversaries before they strike. ",
      content: (
        <SimpleList
          points={[
            "Integrates behavioral and threat intel feeds (via Sophos) to enhance detection accuracy. ",
            "Correlates attack patterns with internal telemetry for early-stage alerting. ",
            "Enables faster identification of emerging malware, TTPs, & adversary infrastructure. ",
          ]}
        />
      ),
      conclusion: "Stay a step ahead with intelligence-driven defense. ",
    },
    {
      title: "MITRE ATT&CK Framework Alignment ",
      subTitle:
        "Mapped to the MITRE ATT&CK® framework for complete visibility into attacker behavior. ",
      content: (
        <SimpleList
          points={[
            "Aligns detection rules and alerts with known adversary tactics, techniques, and procedures (TTPs). ",
            "Helps security teams understand threat context and response strategy. ",
            "Supports red/blue team validation and compliance mapping. ",
          ]}
        />
      ),
      conclusion: "See threats not just by signature — but by strategy. ",
    },
    {
      title: "Attack Surface Management (ASM) ",
      subTitle:
        "Expand protection beyond the endpoint by understanding and reducing your total attack surface. ",
      content: (
        <SimpleList
          points={[
            "Continuous visibility into exposed assets across cloud, on-prem, and hybrid environments. ",
            "Identifies misconfigurations, shadow IT, and third-party risk. ",
            "Prioritizes vulnerabilities based on exploitability and business context. ",
          ]}
        />
      ),
      conclusion:
        "Discover. Monitor. Shrink your attack surface — before attackers find a way in. ",
    },
  ],
  button: {
    label: "Ready To Try ?",
    link: "contact-us",
  },
};
